import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { WebSocketSubject, webSocket } from 'rxjs/webSocket';

import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root',
})
export class SpeechToTextService {
	private socket$: WebSocketSubject<Blob>;
	private textSource = new Subject<string>();
	textChanged$ = this.textSource.asObservable();

	public connectWebSocket(): void {
		if (!this.socket$ || this.socket$.closed) {
			this.socket$ = webSocket<Blob>({
				url: environment.speechToTextUrl,
				binaryType: 'blob',
				deserializer: (response) => response?.data || '',
				serializer: (value) => value,
			});
		}
	}

	public disconnectWebSocket(): void {
		if (this.socket$) {
			this.socket$.complete();
			this.socket$ = null;
		}
	}

	public sendBinary(message: Blob): void {
		if (this.socket$) {
			this.socket$.next(message);
		}
	}

	public listen(): Observable<any> {
		return this.socket$?.asObservable();
	}

	public setText(text: string) {
		this.textSource.next(text);
	}
}
